import * as PIXI from "pixi.js";
import * as pp from "@pixi/particle-emitter";
import gsap from "gsap";

import { Signal } from "signals";
import ServiceLocator from "../../ServiceLocator";
import Player, { game_side_type } from "./Player";
import { IGameLayers } from "../GameplayScreen";
import ComicBubble from "./ComicBubble";


export default class GameOverAnimation extends PIXI.Container
{
    private _isWin: boolean = null;
    private _winner: Player = null;
    private _arrPlayer: Array<Player> = null;
    private _gameLayers: IGameLayers = null;

    private _bg: PIXI.Sprite = null;
    private _arrPortraitWrapper: Array<PIXI.Container> = null;
    private _banner: PIXI.Sprite = null;
    private _glow: PIXI.Sprite = null;
    private _crown: PIXI.Sprite = null;
    private _comicBubble: ComicBubble = null;
    
    private _arrPortraitWrapperPos: Array<PIXI.Point> = null;

    private _sparkEmitter: pp.Emitter = null;

    private _tl: gsap.core.Timeline = null;

    private _onCompleted: Signal = null;


    public set isWin( value: boolean ) { this._isWin = value; }
    public set winner( value: Player ) { this._winner = value; }
    public set players( value: Array<Player> ) { this._arrPlayer = value; }
    public set gameLayers( value: IGameLayers ) { this._gameLayers = value; }

    public get onCompleted(): Signal { return this._onCompleted; }


    public constructor() { super(); }

    public init(): void
    {
        console.assert( this._isWin != null, "GameOverAnimation.ts :: init() :: this._isWin cannot be null." );
        console.assert( this._winner != null, "GameOverAnimation.ts :: init() :: this._winner cannot be null." );
        console.assert( this._arrPlayer != null, "GameOverAnimation.ts :: init() :: this._players cannot be null." );
        console.assert( this._gameLayers != null, "GameOverAnimation.ts :: init() :: this._gameLayers cannot be null." );

        this._onCompleted = new Signal();

        this._bg = new PIXI.Sprite( ServiceLocator.resources.tut_bg.texture );
        this._bg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._bg.anchor.set( 0.5 );
        this.addChild( this._bg );
        //
        this._bg.visible = false;

        this._arrPortraitWrapper = [];
        this._arrPortraitWrapperPos = [];
        for ( let player of this._arrPlayer )
        {
            ( player as Player ).setHighlighted( false );

            let portraitWrapper: PIXI.Container = ( player as Player ).portraitWrapper;
            this._arrPortraitWrapperPos.push( new PIXI.Point( portraitWrapper.x, portraitWrapper.y ) );
            this._arrPortraitWrapper.push( portraitWrapper );
            //
            const kPortraitWrapperGlobalPos: PIXI.Point = this._gameLayers.player.toLocal( portraitWrapper.getGlobalPosition() );
            console.log( "side=" + player.side + " :: "+ kPortraitWrapperGlobalPos );
            this.addChild( portraitWrapper );
            portraitWrapper.position.copyFrom( kPortraitWrapperGlobalPos );
        }

        this._banner = new PIXI.Sprite( ServiceLocator.resources.tut_header_base.texture );
        this._banner.visible = false;
        this._banner.anchor.set( 0.5 );
        this._banner.position.set( ServiceLocator.app.width * 0.5, 218 );
        this.addChild( this._banner );
        //
        if ( this._isWin )
        {
            let bannerTitleWrapper: PIXI.Container = new PIXI.Container();
            this._banner.addChild( bannerTitleWrapper );
            //
            let gameLogo: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.game_logo.texture );
            gameLogo.anchor.set( 0, 0.5 );
            gameLogo.scale.set( 0.5 );
            gameLogo.y -= 10;
            bannerTitleWrapper.addChild( gameLogo );
            //
            let bannerText: PIXI.Text = new PIXI.Text( "YOU WIN!", { fontFamily: "asap_bold", fontSize: 70, fill: 0xffffdf } );
            bannerText.anchor.set( 0, 0.5 );
            bannerText.x = gameLogo.width + 30;
            bannerTitleWrapper.addChild( bannerText );
            //
            bannerTitleWrapper.x = -bannerTitleWrapper.width * 0.5;
        }
        else
        {
            let bannerText: PIXI.Text = new PIXI.Text( "Maybe next time...", { fontFamily: "asap_bold", fontSize: 80, fill: 0xffffdf } );
            bannerText.anchor.set( 0.5 );
            this._banner.addChild( bannerText );
        }
        //
        this._banner.visible = false;

        this._glow = new PIXI.Sprite( ServiceLocator.resources.winner_glow.texture );
        this._glow.anchor.set( 0.5 );
        this._glow.position.copyFrom( this._arrPortraitWrapper[ this._winner.id ].position );
        if ( this._winner.side != game_side_type.SOUTH )
        {
            this._glow.y += 320;
        }
        this.addChildAt( this._glow, 1 );
        //
        this._glow.visible = false;

        this._crown = new PIXI.Sprite( ServiceLocator.resources.crown.texture );
        this._crown.anchor.set( 0.5, 1 );
        this._crown.position.copyFrom( this._glow.position );
        this._crown.y -= 36;
        this.addChild( this._crown );
        //
        this._crown.visible = false;

        this._sparkEmitter = new pp.Emitter(
            new PIXI.Container(),
            pp.upgradeConfig( 
                ServiceLocator.resources[ "emitter_crown" ].data, 
                [ ServiceLocator.resources[ "spark_01" ].texture ] ) );
        this._sparkEmitter.autoUpdate = false;
        this._sparkEmitter.emit = false;
        this._sparkEmitter.parent.position.copyFrom( this._crown.position );
        this._sparkEmitter.parent.y -= 20;
        this.addChild( this._sparkEmitter.parent );

        this._comicBubble = new ComicBubble();
        const kScaleX: number = this._winner.side == game_side_type.WEST ? -1 : 1;
        this._comicBubble.setText( "I win!", kScaleX );
        this._comicBubble.setPlayerSide( this._winner.side );
        this._comicBubble.scale.x = kScaleX;
        if ( this._winner.side != game_side_type.SOUTH )
        {
            this._comicBubble.y += 320;
        }
        this.addChild( this._comicBubble );
        //
        this._comicBubble.visible = false;
    }

    public end(): void
    {
        this._onCompleted.dispose();
        this._onCompleted = null;

        let playerIndex: number = 0;
        for ( let player of this._arrPlayer )
        {
            this._arrPortraitWrapper[ playerIndex ].position.copyFrom( this._arrPortraitWrapperPos[ playerIndex ] );
            if ( player.side == game_side_type.SOUTH )
            { 
                player.addChildAt( this._arrPortraitWrapper[ playerIndex ], 0 );
            }
            else
            {
                player.addChild( this._arrPortraitWrapper[ playerIndex ] );
            }

            ++playerIndex;
        }

        if ( this._tl )
        {
            this._tl.kill();
            this._tl = null;
        }

        this._sparkEmitter.destroy();
        this._sparkEmitter = null;
    }

    public update( dt: number ): void
    {
        this._sparkEmitter.update( dt );
    }

    public play(): void
    {
        this._tl = new gsap.core.Timeline();

        this._banner.visible = true;
        this._banner.scale.y = 0;

        this._glow.visible = true;
        this._glow.alpha = 0;

        this._crown.visible = true;
        this._crown.alpha = 0;

        this._bg.visible = true;
        this._tl.from( this._bg, { alpha: 0, duration: 0.4, ease: "sine.out" }, 0 );

        let i: number = 0;
        for ( let portraitWrapper of this._arrPortraitWrapper )
        {
            if ( this._arrPlayer[ i ].side != game_side_type.SOUTH )
            {
                this._tl.to( portraitWrapper, { y: "+=320", duration: 0.8, ease: "sine.out" }, 0 );
            }

            ++i;
        }

        this._tl.to( this._banner.scale, { y: 1, duration: 0.2, ease: "sine.in" }, 0.8 );
        this._tl.to( this._glow, { alpha: 1, duration: 0.4, ease: "sine.in" }, "<" );
        this._tl.from( this._crown, { y: "-=80", duration: 0.4, ease: "sine.out" }, "<" );
        this._tl.to( this._crown, { alpha: 1, duration: 0.4, ease: "sine.out" }, "<" );
        this._tl.call( () => { this._sparkEmitter.playOnce(); }, null, ">" );
        this._tl.call( () => { this._comicBubble.visible = true; }, null, ">" );
        this._tl.from( this._comicBubble.scale, { x: 0, y: 0, duration: 1, ease: "elastic.out" }, "<" ); 
        this._tl.to( this._comicBubble, { alpha: 0, duration: 0.4, ease: "sine.in" }, "<+1.4" ); 
        this._tl.call( () => { this._onCompleted.dispatch(); }, null, ">+1" );
        //
        ServiceLocator.game.tweenGroup.add( this._tl );

        ServiceLocator.audio.playSfx( this._winner.side == game_side_type.SOUTH ? "win_round" : "end_round" );
    }
}